import React, { useState } from "react";
import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Menu,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  Upload as UploadIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { useTranslation } from 'react-i18next';
import SellTrades from "./Withdrawls.component";
import BuyTrades from "./Deposits.component";
// import TopTradersComponent from "./TopTrader.component";
// import LoserTradersComponent from "./deposits.component";

const timeOffsets = {
  "1s": 1000,
  "1min": 60 * 1000,
  "5min": 5 * 60 * 1000,
  "15min": 15 * 60 * 1000,
  "1h": 60 * 60 * 1000,
  "4h": 4 * 60 * 60 * 1000,
  "12h": 12 * 60 * 60 * 1000,
  "1d": 24 * 60 * 60 * 1000,
  "1w": 7 * 24 * 60 * 60 * 1000,
  "1m": 30.44 * 24 * 60 * 60 * 1000,
};

const timeDisplayMap = {
  "1s": "1s",
  "1min": "1m",
  "5min": "5m",
  "15min": "15m",
  "1h": "1h",
  "4h": "4h",
  "12h": "12h",
  "1d": "1d",
  "1w": "1w",
  "1m": "1M",
};

const EpicTransfers = () => {
  const { t } = useTranslation();

  const [selectedTimeOffset, setSelectedTimeOffset] = useState("1h");
  const [selectedCategory, setSelectedCategory] = useState("withdrawls");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleButtonClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTimeOffsetsChange = (timeOffset) => {
    setSelectedTimeOffset(timeOffset);
    handleClose();
  };

  const handleCategoryChange = (event, newCategory) => {
    if (newCategory !== null) {
      setSelectedCategory(newCategory);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        flex: 1,
        // backgroundColor: "red",
        // maxWidth: 600,
        height: "100%", // Ensures it doesn’t collapse
        display: "flex",
        // alignItems: "stretch",
        flexDirection: "column", // Prevents shrinking
        // mx: "auto",
        p: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // backgroundColor: "red",
          //   p: 1,
          //   borderRadius: 1,
          //   boxShadow: 1,
          //   gap: 1,
          // minHeight: 40, // Compact height
          width: "100%",
        }}
      >
        <Typography
          variant="subtitle2"
        //   sx={{ flexGrow: 1, textAlign: "center" }}
        >
          {
            selectedCategory === "withdrawls" ? `Epic BTC ${ t('analytics.withdrawals', 'Withdrawals') }`
              : `Epic BTC ${ t('analytics.deposits', 'Deposits') }`
          }
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {/* Toggle Buttons for withdrawals/deposits */}
          <ToggleButtonGroup
            value={selectedCategory}
            exclusive
            onChange={handleCategoryChange}
            size="small"
            sx={{
              '& .MuiToggleButton-root': {
                border: '1px solid rgba(255,255,255,0.4)',
                color: 'inherit',
                padding: '4px 8px',
                minWidth: 'unset',
                '&:hover': {
                  borderColor: 'rgba(255,255,255,0.6)',
                },
                '&.Mui-selected': {
                  backgroundColor: 'rgba(255,255,255,0.1)',
                  borderColor: 'rgba(255,255,255,0.6)',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.15)',
                  }
                }
              }
            }}
          >
            <ToggleButton value="withdrawls" aria-label={t('analytics.withdrawals', 'withdrawals')}>
              <UploadIcon fontSize="small" />
            </ToggleButton>
            <ToggleButton value="deposits" aria-label={t('analytics.deposits', 'deposits')}>
              <DownloadIcon fontSize="small" />
            </ToggleButton>
          </ToggleButtonGroup>

          {/* Time Interval Selector */}
          <Box sx={{ position: 'relative' }}>
            <Button
              variant="outlined"
              onClick={handleButtonClick}
              endIcon={<ExpandMoreIcon />}
              size="small"
              sx={{
                border: "1px solid rgba(255,255,255,0.4)",
                color: 'inherit',
                padding: '0px',
                '&:hover': {
                  borderColor: 'rgba(255,255,255,0.6)',
                }
              }}
            >
              {timeDisplayMap[selectedTimeOffset]}
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'time-interval-button',
              }}
              PaperProps={{
                sx: {
                  minWidth: anchorEl?.offsetWidth || 80,
                }
              }}
            >
              {Object.keys(timeOffsets).map((key) => (
                <MenuItem
                  key={key}
                  onClick={() => handleTimeOffsetsChange(key)}
                  selected={key === selectedTimeOffset}
                >
                  {timeDisplayMap[key]}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Box>
      </Box>

      {selectedCategory === "withdrawls" && <SellTrades selectedTimeOffset={selectedTimeOffset} />}
      {selectedCategory === "deposits" && <BuyTrades selectedTimeOffset={selectedTimeOffset} />}

    </Box>
  );
};

export default EpicTransfers;
